import { render, staticRenderFns } from "./NewsSection.vue?vue&type=template&id=01ba8eb0"
import script from "./NewsSection.vue?vue&type=script&lang=js"
export * from "./NewsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewsItem: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/NewsItem.vue').default,SectionContainer: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/SectionContainer.vue').default})
